import { AuthState } from '@okta/okta-auth-js';

import { LocationGroups } from '../../services/backend/LocationGroups';
import { useBaseApiClient } from '../useBaseApiClient';

export const useLocationGroups: () => LocationGroups<AuthState> = () => {
  return useBaseApiClient(LocationGroups);
};
